// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";

@Component({
  selector: "app-new-secure-board-list",
  templateUrl: "./new-lottery-list.component.html",
  styleUrls: ["./new-lottery-list.component.scss"],
})
export class NewLotteryListComponent implements OnInit {
  page: Page<LotteryResponseModel>;
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  dataSourceLottery: MatTableDataSource<LotteryResponseModel> =
    new MatTableDataSource();
  nonEditable: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "lotteryCode",
    "lotteryName",
    "lotteryBoard",
    "lotteryStage",
    "action",
  ];

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchNewLotteryList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isSearchDisabled = false;
          if (data.status === "SUCCESS") {
            this.page = data.page;
            this.dataSourceLottery = new MatTableDataSource(this.page.content);
            this.nonEditable = data.nonEditable;
            console.log(this.page.content);
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = this.page.totalElements;
              console.log(this.paginator.pageIndex);
              console.log(this.paginator.length);
            });
          } else {
            this.nonEditable = true;
            this.masterService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
          this.nonEditable = true;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      console.log("onSearch");
      console.log(this.filterForm.valid);
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Lottery",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  // ngAfterViewInit() {
  //   this.loadData();
  // }

  // ngAfterViewInit(): void {
  //   // this.dataSourceLottery.sort = this.sort;
  //   // this.dataSourceLottery.paginator = this.paginator;
  //   this.loadData();
  // }

  // loadData() {
  //   this.masterService.getLotteryList().subscribe((page: any)=>{
  //     console.log(page.content);
  //     this.page = page;
  //     this.dataSource = new MatTableDataSource(page.content);
  //     setTimeout(() => {
  //       this.paginator.pageIndex = this.currentPage;
  //       this.paginator.length = page.totalElements;
  //     });
  //   });
  // }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  editLottery(lotteryKey: number) {
    console.log("Edit Board called ******** key for board edit" + lotteryKey);
    this.router.navigate([
      "/secure",
      "master",
      "new-lottery",
      "au",
      lotteryKey,
    ]);
  }

  generateHashcode(lotteryKey: number) {
    console.log("Generate Hashcode called ******** key" + lotteryKey);
    this.router.navigate([
      "/secure",
      "master",
      "new-lottery",
      "au",
      lotteryKey,
      "HASHCODE",
    ]);
  }

  changeLotteryStage(lotteryKey: number) {
    console.log("Lottery Stage called ******** key" + lotteryKey);
    this.router.navigate([
      "/secure",
      "master",
      "new-lottery",
      "au",
      lotteryKey,
      "LOTTERY_STAGE",
    ]);
  }

  deactivate(key: number) {
    if (confirm("Do you want to De-Activate the Lottery")) {
      console.log("Key for deactivate " + key);
      this.masterService
        .deactivateNewLottery(key, "N")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.activeFlag = "N";
          } else {
            this.errorToast(data.errorMessage);
          }
        });
    }
  }

  activate(key: number) {
    if (confirm("Do you want to Activate the Lottery")) {
      console.log("Key for activate " + key);
      this.masterService
        .deactivateNewLottery(key, "Y")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.activeFlag = "Y";
          } else {
            this.errorToast(data.errorMessage);
          }
        });
    }
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
